import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { BACKEND } from "../../config/configEnvs";
import { FaSearch, FaIdCard, FaTimes, FaEye, FaTrash, FaComment} from "react-icons/fa";
import CotizacionItemRow from "../ItemsTable/CotizacionItemRow";
import DrawerCotizacionDetails from "../ItemsTable/DrawerCotizacionDetails";
import NuevaCotizacionDialog from "../dialogs/NuevaCotizacionDialog";
import { convertFirstLetterCapital } from "../../helpers/stringsHelper";
import { toast } from "react-toastify";
import { MdClose } from "react-icons/md";
import FilterSeguimientoClienteDialog from "../dialogs/FilterSeguimientoClienteDialog";
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import PaginationItem from "../ui/components/Pagination";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import LoadingScreen from "../ui/temp-screens/LoadingScreen";
import NoDataScreen from "../ui/temp-screens/NoDataScreen";
import { CotizacionBarraMetadata } from "./CotizacionBarraMetadata";
import SearchIcon from '@mui/icons-material/Search';
import { getStartAndEndOfMonth, getToday } from "../../utils/GetDates";
import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import NormalizeText from "../../utils/normalizeValues/NormalizeText";


const TablaCotizaciones = ({ userRedux }) => {

  const isAdmin = userRedux.area.toUpperCase() === "ADMINISTRACION" && userRedux.puesto.toUpperCase() !== "ASISTENTE"
  const isAssistant = userRedux.puesto.toUpperCase() === "ASISTENTE"
  const isGestionAdmi = userRedux?.puesto?.toUpperCase() === "GESTION ADMI"

  const { start, end } = getStartAndEndOfMonth();

  const [cotizacionesList, setCotizacionesList] = useState([]);

  const [page, setPage] = useState(1);

  const [serviciosMetaData, setServiciosMetaData] = useState({
    totalPages: 0,
    page: 0,
    hasPrevPage: false,
    hasNextPage: false,
    totalDocs: 0,
  });
  const [activeAgency, setActiveAgency] = useState(false);

  const [loadingStatus, setLoadingStatus] = useState(false)
  const [addNewCotOpen, setAddNewCotOpen] = useState(false);

  const [activeCotizacionData, setActiveCotizacionData] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [vendedoresList, setVendedoresList] = useState([]);

  const [limit, setLimit] = useState(50);
  const [openClienteDialog, setOpenClienteDialog] = useState(false);

  const [brands, setBrands] = useState([])

  const [lead, setLead] = useState("")
  const [leadValue, setLeadValue] = useState("leadName")

  const [currencyExchanges, setCurrencyExchanges] = useState({})
  const [paises, setPaises] = useState([])

  const getPaises = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/paises?limit=0`)
      setPaises(response.data.docs)
    } catch (error) {
      return false
    }
  }

  const getCurrencyExchange = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/tiposCambio?limit=0`)
      const currencyExchanges = response.data.docs.reduce((acc, item) => {
        acc[item.moneda] = item.tipoCambio
        return acc
      }, {})
      setCurrencyExchanges(currencyExchanges)
    } catch (error) {
      return false
    }
  }

  const statusColor = {
    "Exito": "text-green-500",
    "En espera": "text-yellow-300",
    "Perdido": "text-red-500",
    "Anulada": "text-black"
  }

  const subStatusColor = {
    "Seleccionar": "text-gray-400",
    "Exito": "text-green-500",
    
    "Evaluando opciones": "text-yellow-500",
    "Para el futuro": "text-blue-400",
    "Frio": "text-sky-500",
    "Por confirmar depósito": "text-orange-400",

    "Curioso": "text-blue-300",
    "No responde": "text-red-400",
    "El servicio le parece caro": "text-red-500",
    "Decidió trabajar con otra agencia": "text-red-600",
    "Competencia o sospechoso": "text-red-700",
    "Lead con poco presupuesto": "text-orange-500"
  }

  const defaultFilters = {
    estado: isGestionAdmi ? "Exito" : "",
    numRenovacion: null,
    servicio: null,
    plan: null,
    responsable: null,
    vendedor: [],
    cliente: null,
    fechaInicio: start,
    fechaFin: end,
    fechaFiltro: "fechaVenta",
    subEstado: ""
  };
  
  const [filterForms, setFilterForms] = useState(() => {
    const filters = defaultFilters;
    // Si es GESTION ADMI, forzar estado "Exito"
    if (isGestionAdmi) {
      filters.estado = "Exito";
      filters.subEstado = "";
    }
    return filters;
    // const savedFilters = localStorage.getItem("cotizaciones-filters");
    // return savedFilters ? JSON.parse(savedFilters) : defaultFilters;
  });


  const getBrands = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/marcas?limit=0&sort=createdAt`)
      setBrands(response.data.docs)
    } catch (e) {
      return false
    }
  }

  useEffect(() => { // Solo se ejecuta cuando se vacea la barra de búsqueda
    if (lead === "") {
      fetchCotizaciones(); // Solo se ejecuta cuando se reinicia la búsqueda
      setPage(1); // Reiniciar la paginación si es necesario
    }
  }, [lead]);

  useEffect(() => {
    localStorage.setItem("cotizaciones-filters", JSON.stringify(filterForms));
  }, [filterForms]);

  const resetFilters = () => {
    const filtersToSet = isGestionAdmi 
      ? { ...defaultFilters, estado: "Exito" }
      : defaultFilters;
    setFilterForms(filtersToSet);
    localStorage.removeItem("cotizaciones-filters");
  };

  const[idCot, setIdCot] = useState("")
  const[filteredCotId, setFilteredCotId] = useState(false)

  useEffect(() => {
    if (
      userRedux.puesto.toUpperCase() === "JEFE COMERCIAL" ||
      userRedux.puesto.toUpperCase() === "GERENTE GENERAL" ||
      userRedux?.puesto?.toUpperCase() === "JEFE DE PROYECTOS" ||
      userRedux?.puesto?.toUpperCase() === "ASISTENTE" ||
      userRedux?.puesto?.toUpperCase() === "ADMINISTRADOR" ||
      userRedux?.puesto?.toUpperCase() === "SUPERVISOR CONTROL DE CALIDAD" ||
      userRedux.puesto.toUpperCase() === "EJECUTIVO DE CUENTAS" ||
      userRedux.puesto.toUpperCase() === "ASESOR DE VENTAS"
    ) {
      fetchCotizaciones("");
    } else if (userRedux.puesto.toUpperCase() === "JEFE DE MARKETING") {
      fetchCotizaciones(`where[cotizador][equals]=${userRedux?.id}`);
    }
  }, [page, limit, filterForms, activeAgency]);

  const fetchCotizaciones = async () => {
    if (!userRedux) return;
  
    const baseUrl = `${BACKEND}/api/cotizaciones`;
    const queryParams = {
      page,
      limit,
      'where[estado][not_equals]': 'Perdido',
      ...((!isAdmin && !isAssistant) && { 'where[cotizador][equals]': userRedux?.id })
    };
  
    let andFilters = [];
  
    // Fecha: agrupar como and[]
    if (filterForms.fechaInicio) {
      andFilters.push({
        [`${filterForms.fechaFiltro}`]: {
          greater_than_equal: new Date(filterForms.fechaInicio).toISOString(),
        }
      });
    }
  
    if (filterForms.fechaFin) {
      andFilters.push({
        [`${filterForms.fechaFiltro}`]: {
          less_than_equal: new Date(filterForms.fechaFin).toISOString(),
        }
      });
    }
  
    // Otros filtros (estado, cliente, vendedor)
    // Filtro de activoAgencia solo para cotizaciones de clientes (no leads)
    if (activeAgency) {
      // Solo aplicar el filtro si hay un cliente (no lead)
      // Usamos OR para incluir cotizaciones de leads Y cotizaciones de clientes activos
      queryParams['where[or][0][cliente][exists]'] = false; // Incluir cotizaciones de leads
      queryParams['where[or][1][and][0][cliente][exists]'] = true; // Cotizaciones con cliente
      queryParams['where[or][1][and][1][cliente.activoAgencia][equals]'] = true; // Y cliente activo
    } else {
      // Si no está activo el filtro, mostrar todas las cotizaciones
      // (tanto de leads como de clientes)
    }

    // Para GESTION ADMI, siempre filtrar por estado "Exito"
    if (isGestionAdmi) {
      queryParams['where[estado][equals]'] = "Exito";
    } else if (filterForms.estado) {
      queryParams['where[estado][equals]'] = filterForms.estado;
    }
  
    if (filterForms.vendedor.length > 0) {
      queryParams['where[cotizador][in]'] = filterForms.vendedor;
    }

    if (filterForms.marca) {
      queryParams['where[marca][equals]'] = filterForms.marca;
    }
  
    if (filterForms.cliente) {
      queryParams['where[cliente][equals]'] = filterForms.cliente.id;
    }

    // Para GESTION ADMI, no aplicar filtro de subEstado
    if (!isGestionAdmi && filterForms.subEstado) {
      queryParams['where[subEstado][equals]'] = filterForms.subEstado;
    }

    if (lead) {
      if (leadValue === "dni") {
        queryParams['where[lead.dni][like]'] = lead;
      } else if (leadValue === "phone") {
        queryParams['where[lead.phone][like]'] = lead;
      } else if (leadValue === "leadName") {
        queryParams['where[lead.leadName][like]'] = lead;
      }
    }
  
    // Si hay filtros AND, los agregamos al query
    if (andFilters.length > 0) {
      andFilters.forEach((filter, index) => {
        const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
        const value = Object.values(Object.values(filter)[0])[0];
        queryParams[key] = value;
      });
    }
  
    // Convertimos todo a query string
    const queryString = new URLSearchParams(queryParams).toString();
  
    try {
      setLoadingStatus(true)

      const response = await axios.get(`${baseUrl}?${queryString}`);
  
      setCotizacionesList(response.data.docs);
      setServiciosMetaData({
        totalPages: response.data.totalPages,
        page: response.data.page,
        hasNextPage: response.data.hasNextPage,
        hasPrevPage: response.data.hasPrevPage,
        totalDocs: response.data.totalDocs,
      });
    } catch (e) {
      toast.error("Error al cargar los datos: " + e);
    } finally {
      setLoadingStatus(false)
    }
  };

  useEffect(() => {
    fetchVendedores();
    getBrands()
    getPaises()
    getCurrencyExchange()
  }, []);

  const fetchVendedores = async () => {
    const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0`);
    const vendedores = response.data.docs.filter((v) => v.area.toUpperCase() === "COMERCIAL" || v.area.toUpperCase() === "ADMINISTRACION")
    setVendedoresList(vendedores)
  };

  const fetchById = async(event) => {
    event.preventDefault();
    try {
      const response = await axios.get(
        `${BACKEND}/api/cotizaciones/${idCot}`
      );

      setCotizacionesList([response.data]);
      setServiciosMetaData({
        totalPages: 1,
        page: 1,
        hasNextPage: false,
        hasPrevPage: false,
        totalDocs: 1,
      });
      setFilteredCotId(true)
    } catch (error) {
      toast.info("No se encontró una cotización con este ID")
    }

  }
  
  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const handleReturnCotGeneral = async () => {
    setFilteredCotId(false);
    setIdCot("")
    if (
      userRedux.puesto.toUpperCase() === "JEFE COMERCIAL" ||
      userRedux?.puesto?.toUpperCase() === "GERENTE GENERAL" ||
      userRedux?.puesto?.toUpperCase() === "JEFE DE PROYECTOS" ||
      userRedux?.puesto?.toUpperCase() === "ASISTENTE" || 
      userRedux?.puesto?.toUpperCase() === "SUPERVISOR CONTROL DE CALIDAD" ||
      userRedux.puesto.toUpperCase() === "EJECUTIVO DE CUENTAS" ||
      userRedux.puesto.toUpperCase() === "ASESOR DE VENTAS" 
    ) {
     await fetchCotizaciones("");
    } else if (userRedux?.puesto?.toUpperCase() === "SUPERVISOR CONTROL DE CALIDAD") {
      await fetchCotizaciones(`where[cotizador][equals]=${userRedux?.id}`);
    }
  }

  const handleSellerFilterChange = (event) => {
    setFilterForms((prev) => ({ ...prev, vendedor: event.target.value }));
  };
  
  const ITEM_HEIGHT = 48;

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 6.5,
        width: 200,
      },
    },
  };

  return (
    <div className="flex flex-col h-screen w-full">
      <NuevaCotizacionDialog
        open={addNewCotOpen}
        onClose={() => setAddNewCotOpen(false)}
        title={"Nueva cotización"}
        onSuccess={() => fetchCotizaciones()}
      />

      <FilterSeguimientoClienteDialog
        setFilterForms={setFilterForms}
        open={openClienteDialog}
        setOpen={setOpenClienteDialog}
      />

      <DrawerCotizacionDetails
        setCotizacionesList={setCotizacionesList}
        cotizacionesList={cotizacionesList}
        open={openDrawer}
        dataDrawer={activeCotizacionData}
        onClose={() => setOpenDrawer(false)}
        brands={brands}
        paises={paises}
        currencyExchanges={currencyExchanges}
      />

      {/* Header */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <div className="flex items-center gap-4 p-4">
            <FaIdCard className="text-2xl text-gray-700" />
            <h2 className="text-2xl font-bold text-gray-700">Cotizaciones</h2>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            {/* Filtrar activos agenciao */}
            <div className="flex flex-row items-center justify-center gap-2">
              <span className="text-xs whitespace-nowrap">Activos agencia</span>
              <input
                type="checkbox"
                className="rounded-md border-gray-400 hover:cursor-pointer"
                checked={activeAgency}
                onChange={(e) => setActiveAgency(e.target.checked)}
              />
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <form onSubmit={fetchById} className="flex flex-row gap-4 items-center justify-center">
                <label className="block text-xs font-medium text-gray-900">
                  Buscar por ID
                </label>
                <div className="flex items-start h-full max-w-sm mx-auto">
                  <div className="relative w-[16rem]">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                      <FaSearch className="w-3 h-3 text-gray-500 dark:text-gray-400" />
                    </div>
                    <input
                      type="text"
                      id="idsearch"
                      value={idCot}
                      onChange={(e)=>setIdCot(e.target.value)}
                      className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent text-gray-900 rounded-lg block w-full ps-10 p-1.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Cotización ID"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="p-2 ms-2 text-xs font-medium text-white bg-blue-700 rounded-lg border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    <FaSearch className="w-3 h-3"/>
                    <span className="sr-only">Search</span>
                  </button>
                </div>
              </form>
            </div>
            
            <div>
              <Button 
                variant="contained"
                onClick={() => setAddNewCotOpen(true)}
                endIcon={<AddIcon/>}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  whiteSpace: "nowrap",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
              >
                Nueva cotización
              </Button>
            </div>

          </div>

        </div>
        
      </div>
      
      {/* Barra de filtros */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10">
        <div className="flex flex-row w-full items-center justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex flex-row gap-4 items-center justify-start mr-4">

            {/* Estado */}
            {!isGestionAdmi && (
              <div className="flex flex-row items-center justify-center gap-4">
                <label
                  htmlFor="estadoServicio"
                  className="block text-xs font-medium text-gray-900 "
                >
                  Estado
                </label>
                <select
                  value={filterForms.estado}
                  onChange={(e) => {
                    setFilterForms((prev) => ({ ...prev, estado: e.target.value, subEstado: "" }));
                    setPage(1);
                  }}
                  id="estadoServicio"
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                >
                  <option value={""}> Todos </option>
                  <option value={"Exito"}>Exito</option>
                  <option value={"Perdido"}>Perdido</option>
                  <option value={"En espera"}>En espera</option>
                  <option value={"Anulada"}>Anulada</option>
                </select>
              </div>
            )}

            {/* Sub estado */}
            {!isGestionAdmi && (
              <div className="flex flex-row items-center justify-center gap-4">
                <label className="block text-xs font-medium text-gray-900">
                  Subestado
                </label>
                <select
                  value={filterForms.subEstado}
                  onChange={(e) => {
                    setFilterForms((prev) => ({ ...prev, subEstado: e.target.value }));
                    setPage(1);
                  }}
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] w-[250px]"
                >
                  <option value={""}> Todos </option>
                  {filterForms.estado === "Exito" ? (
                    <>
                      <option value="Exito">Exito</option>
                    </>
                  ) : filterForms.estado === "En espera" ? (
                    <>
                      <option value="Evaluando opciones">Evaluando opciones</option>
                      <option value="Para el futuro">Para el futuro</option>
                      <option value="Frio">Frio</option>
                      <option value="Por confirmar depósito">Por confirmar depósito</option>
                    </>
                  ) : filterForms.estado === "Perdido" && (
                    <>
                      <option value="Curioso">Curioso</option>
                      <option value="No esta en mi ciudad">No esta en mi ciudad</option>
                      <option value="No responde">No responde</option>
                      <option value="El servicio le parece caro">El servicio le parece caro</option>
                      <option value="Decidió trabajar con otra agencia">Decidió trabajar con otra agencia</option>
                      <option value="Decidió trabajar con un freelancer">Decidió trabajar con un freelancer</option>
                      <option value="Competencia o sospechoso">Competencia o sospechoso</option>
                      <option value="Lead con poco presupuesto">Lead con poco presupuesto</option>
                    </>
                  )}

                </select>
              </div>
            )}
            
            {/* Vendedor */}
            {(isAdmin || isAssistant) && (
              <div className="flex flex-row items-center justify-center gap-4">
                <label className="block text-xs font-medium text-gray-900 ">
                  Vendedor
                </label>
                <FormControl sx={{ borderRadius: "8px", height: 32, width: "10vw", backgroundColor: "white" }}>
                  <InputLabel
                    sx={{
                      fontSize: 12,
                      transform: "translate(14px, 6.5px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -6px) scale(0.75)",
                      },
                    }}
                  >
                    Todos
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    sx={{
                      height: 32,
                      display: "flex",
                      alignItems: "center",
                      fontSize: 12,
                      borderRadius: "8px",
                    }}
                    id="demo-multiple-checkbox"
                    multiple
                    value={filterForms.vendedor}
                    onChange={handleSellerFilterChange}
                    input={<OutlinedInput label="Vendedor" sx={{ height: 25, fontSize: 12 }}/>}
                    renderValue={(selected) => {
                      return selected.map(id => {
                        const vendedor = vendedoresList.find(v => v.id === id);
                        return vendedor ? vendedor.name : '';
                      }).filter(Boolean).join(', ');
                    }}                MenuProps={MenuProps}
                  >
                    {vendedoresList.map((e) => (
                      <MenuItem key={e.id} value={e.id} sx={{ height: "30px", width: "40vw" }}>
                        <Checkbox checked={filterForms.vendedor.includes(e.id)} />
                        <ListItemText primary={e.name} primaryTypographyProps={{ fontSize: 12, fontFamily: "poppins" }}/>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            )}

            {/* Cliente */}
            <div className="flex flex-row items-center justify-center gap-4">
              <label
                htmlFor="cliente"
                className="block text-xs font-medium text-gray-900 "
              >
                Cliente
              </label>

              <div className=" flex justify-center gap-2 items-center">
                <button
                  type="button"
                  onClick={() => setOpenClienteDialog(true)}
                  style={{ maxWidth: "200px" }}
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] px-2"
                >
                  {filterForms.cliente ? (
                    <>
                      <span>{filterForms.cliente.nombreComercial}</span>{" "}
                    </>
                  ) : (
                    "Todos"
                  )}
                </button>
                {filterForms.cliente && (
                  <button
                    type="button"
                    onClick={() =>
                      setFilterForms((prev) => ({ ...prev, cliente: null }))
                    }
                    className=" bg-red-600 bg-opacity-10 text-red-600 p-2 rounded-xl"
                  >
                    <MdClose />
                  </button>
                )}
              </div>
            </div>

            {/* Marca */}
            <div className="flex flex-row items-center justify-center gap-4">
              <label className="block text-xs font-medium text-gray-900 ">
                Marca
              </label>

              <select
                id="marca"
                style={{ maxWidth: "200px" }}
                value={filterForms.marca}
                onChange={(e) => {
                  setFilterForms((prev) => ({
                    ...prev,
                    marca: e.target.value,
                  }));
                  setPage(1);
                }}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value={""}> Todos</option>
                {brands.map((e) => (
                  <option value={e.id} key={e.id}>
                    {convertFirstLetterCapital(e.name)}
                  </option>
                ))}
              </select>
            </div>

          </div>
          
          <div className="flex flex-row gap-2 items-center justify-end px-4">
            <Button 
              variant="contained"
              onClick={() => resetFilters(true)}
              endIcon={<RestartAltIcon/>}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins",
                whiteSpace: "nowrap",
      
                minWidth: "140px",     // Evita que el botón se haga demasiado pequeño
                maxWidth: "140px", 
                backgroundColor: "#ff6400",
                transform: "all",
                animationDuration: "1000",
                textTransform: "none",
                borderRadius: "8px",
                '&:hover': {
                  backgroundColor: "#bb4a03",
                }
              }}
            >
              Reiniciar filtros
            </Button>
          </div>

        </div>
      </div>

      {/* Barra de fechas */}
      <div className="flex bg-gray-100 mt-0.5 w-full gap-10">
        <div className="flex w-full justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          {/* Fechas */}
          <div className="flex flex-row gap-4 items-center justify-start w-full px-4">

            <div className="flex flec-row items-center justify-center gap-2">
              <label className="block text-xs font-medium text-gray-900">
                Filtrar por
              </label>

              <select
                value={filterForms.fechaFiltro}
                onChange={(e) =>
                  setFilterForms((prev) => ({
                    ...prev,
                    fechaFiltro: e.target.value,
                  }))
                }
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value={"fechaVenta"}>Fecha venta</option>
                <option value={"createdAt"}>Fecha de creación</option>
                <option value={"fechaCotizacionLimite"}>Fecha vencimiento</option>
              </select>
            </div>
            
            <div className="flex flec-row items-center justify-center gap-2">
              <label className="block text-xs font-medium text-gray-900">
                Fecha inicio
              </label>

              <div className="flex flex-row items-center justify-center gap-4">
                <input 
                  type="date" 
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                  value={filterForms.fechaInicio}
                  onChange={(e) => setFilterForms((prev) => ({ ...prev, fechaInicio: e.target.value }))}
                />
              </div> 
            </div>
            
            <div className="flex flec-row items-center justify-center gap-2">
              <label className="block text-xs font-medium text-gray-900">
                Fecha fin
              </label>

              <div className="flex flex-row items-center justify-center gap-4">
                <input 
                  type="date" 
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                  value={filterForms.fechaFin}
                  onChange={(e) => setFilterForms((prev) => ({ ...prev, fechaFin: e.target.value }))}
                />
              </div> 
            </div>

          </div>  

          {/* Busqueda por leads */}    
          <div className="flex flex-row gap-2 items-center justify-end px-4">
          
            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
              <span className="truncate font-semibold">Buscar por lead:</span>
              <select
                value={leadValue}
                onChange={(e) => setLeadValue(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
              >
                <option value="leadName">Nombre de lead</option>
                <option value="phone">Número de teléfono</option>
                <option value="dni">DNI</option>
              </select>
            </div>

            <div className="relative w-full">
              <input
                type="text"
                placeholder={`Buscar por lead`}
                className="w-[16rem] text-xs text-gray-700 bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
                value={lead}
                onChange={(e) => setLead(e.target.value)}
              />
              {lead && (
                <FaTimes
                  onClick={() => setLead("")}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 cursor-pointer"
                />
              )}
            </div>

            <div>
              <Button
                variant="contained"
                endIcon={<SearchIcon />}
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  fontFamily: "poppins",
                  padding: "4px 24px",
                  backgroundColor: "#ff6400",
                  transform: "all",
                  animationDuration: "1000",
                  textTransform: "none",
                  borderRadius: "8px",
                  '&:hover': {
                    backgroundColor: "#bb4a03",
                  }
                }}
                onClick={() => {
                  // Eliminamos los filtros de fecha
                  setFilterForms((prev) => ({
                    ...prev,
                    fechaInicio: "",
                    fechaFin: "",
                    fechaFiltro: "createdAt"
                  }));
                  
                  // Llamamos a fetchCotizaciones sin los filtros de fecha
                  fetchCotizaciones();
                }}
              >
                Buscar
              </Button>
            </div>

          </div>

        </div>
      </div>    
           
      {/* Metadata */}
      {userRedux.area.toUpperCase() === "ADMINISTRACION" && (
        <CotizacionBarraMetadata 
          query={filterForms}
          activeAgency={activeAgency}
          paises={paises}
          currencyExchanges={currencyExchanges}
          leadValue={leadValue}
          lead={lead}
        />
      )}

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
            <LoadingScreen />
          ) : (
            cotizacionesList.length === 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full text-xs">
                <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
                  <tr className="text-gray-700 text-center text-xs font-bold">
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div className="flex justify-center items-center">
                        <FaEye />
                      </div>
                    </td>
                    {isAdmin && (
                      <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                        <div className="flex justify-center items-center">
                          <FaTrash />
                        </div>
                      </td>
                    )}
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      <div className="flex justify-center items-center">
                        <FaComment />
                      </div>
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Servicios
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Estado
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Subestado
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Última actualización subestado
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Vendedor
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Mes
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Año
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Cliente
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Nombre Lead
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Teléfono{"\n"}Cliente/Lead
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red whitespace-nowrap">
                      Fecha creación
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red whitespace-nowrap">
                      Fecha venta
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red whitespace-nowrap">
                      Fecha vencimiento
                    </td>
                    {/* <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Moneda
                    </td> */}
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      País
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Total
                    </td>
                    <td className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Deuda
                    </td>
                    <td className="px-1 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      N° cuotas
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {cotizacionesList?.map((e) => {
                    const flagUrl = paises.find(p => NormalizeText(p.name) === NormalizeText(e.cliente?.pais || e.lead?.country))?.bandera?.url
                    return (
                    <CotizacionItemRow
                      onSelect={() => {
                        setActiveCotizacionData(e);
                        setOpenDrawer(true);
                      }}
                      onRefresh={() => fetchCotizaciones()}
                      statusColor={statusColor}
                      subStatusColor={subStatusColor}
                      isAdmin={isAdmin}
                      key={e.id}
                      data={e}
                      flagUrl={flagUrl}
                    />
                   )
                  })}
                </tbody>
              </table>
            )
          )
        }

        {filteredCotId &&  
          <div className=" pt-10 flex justify-center">
            <button 
              onClick={handleReturnCotGeneral} 
              type="button" 
              className="bg-orange-500 py-2 px-8 bg-opacity-10 rounded-md text-xs font-bold text-orange-600 hover:bg-opacity-20 transition duration-100">
              Volver a cotizaciones generales 
            </button>  
          </div>
        }
      </div>

      {/* Paginador */}
      <PaginationItem 
        actualDocs={cotizacionesList.length}
        totalDocs={serviciosMetaData.totalDocs}
        entity={"cotizaciones"}
        totalPages={serviciosMetaData.totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>
  );
};

export default TablaCotizaciones;
